import React, { FC, useRef, useState } from 'react'
import { Dropdown, Checkbox } from 'antd'
import Button from '../Button/Button'
import styles from './DropdownMenu.module.scss'

interface Item {
  label: string
  key: string
}

interface IDropdownMenu {
  items: Item[]
  checkedKeys?: string[]
  iconClassName?: string
  children?: React.ReactNode
  setCheckedKeys: React.Dispatch<React.SetStateAction<string[]>>
}

const DropdownMenu: FC<IDropdownMenu> = ({ items, checkedKeys = [], children, setCheckedKeys }) => {
  const [tempCheckedKeys, setTempCheckedKeys] = useState<string[]>(checkedKeys)
  const [visible, setVisible] = useState<boolean>(false)

  const initialCheckedKeys = useRef<string[]>(checkedKeys)

  const handleCheckboxClick = (key: string) => {
    setTempCheckedKeys(prev => (prev.includes(key) ? prev.filter(k => k !== key) : [...prev, key]))
  }

  const handleSubmit = () => {
    setCheckedKeys(tempCheckedKeys)
    setVisible(false)
  }

  return (
    <Dropdown
      trigger={['click']}
      open={visible}
      rootClassName={styles.root}
      onOpenChange={open => setVisible(open)}
      dropdownRender={() => (
        <ul className={styles.listWrapper}>
          {items.map(item => (
            <li
              key={item.key}
              className={tempCheckedKeys.includes(item.key) ? styles.checked : styles.default}
              onClick={() => handleCheckboxClick(item.key)}
            >
              <Checkbox className={styles.checkbox} checked={tempCheckedKeys.includes(item.key)}>
                <span className={styles.label}>{item.label}</span>
              </Checkbox>
            </li>
          ))}
          <div className={styles.actions}>
            <Button buttonType='secondary' onClick={() => setTempCheckedKeys(initialCheckedKeys.current)}>
              Reset
            </Button>
            <Button buttonType='primary' onClick={handleSubmit} className={styles.submit}>
              OK
            </Button>
          </div>
        </ul>
      )}
    >
      <div
        onClick={() => {
          if (visible === false) setVisible(true)
        }}
      >
        {children}
      </div>
    </Dropdown>
  )
}

export default DropdownMenu
